export const translateString = (value: string) => {
  if (value.includes(',')) {
    const [ptName, enName, esName] = value?.split(', ') || [value]

    if (document?.documentElement.lang === 'en') return enName
    if (document?.documentElement.lang === 'es') return esName

    return ptName
  }
  if (value.includes(' | ')) {
    const [ptName, enName, esName] = value?.split(' | ') || [value]

    if (document?.documentElement.lang === 'en') return enName
    if (document?.documentElement.lang === 'es') return esName

    return ptName
  }

  return value
}
